import React from 'react';

const UserIcon = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.99984 6.00002C5.29259 6.00002 4.61432 5.71907 4.11422 5.21897C3.61412 4.71887 3.33317 4.0406 3.33317 3.33335C3.33317 2.62611 3.61412 1.94783 4.11422 1.44774C4.61432 0.947638 5.29259 0.666687 5.99984 0.666687C6.70708 0.666687 7.38536 0.947638 7.88546 1.44774C8.38555 1.94783 8.6665 2.62611 8.6665 3.33335C8.6665 4.0406 8.38555 4.71887 7.88546 5.21897C7.38536 5.71907 6.70708 6.00002 5.99984 6.00002ZM5.99984 8.00002C8.12384 8.00002 10.0298 8.38069 11.3332 10.042V11.3334H0.666504V10.042C1.96984 8.38002 3.87584 8.00002 5.99984 8.00002Z" fill="currentColor" />
  </svg>
);

export default UserIcon;
